import { Check } from "lucide-react";

/** Small orange-outline "Purchased" pill, shown inline with the product code. */
export default function PurchasedBadge({ show }: { show: boolean }) {
  if (!show) return null;
  return (
    <span className="agd:inline-flex agd:flex-shrink-0 agd:items-center agd:gap-1 agd:whitespace-nowrap agd:rounded-full agd:border agd:border-accent agd:bg-[#fff3e8] agd:px-2 agd:py-0.5 agd:text-[0.6rem] agd:font-semibold agd:uppercase agd:tracking-wide agd:text-accent">
      <Check size={10} /> Purchased
    </span>
  );
}

/** Utility: normalize a product description's line breaks and trim it. */
export function getDescText(description: string | undefined): string {
  return (description || "").replace(/\r\n|\r/g, "\n").trim();
}
